import styled from 'styled-components/macro';

export const Strong = styled.strong`
  font-weight: 700;

  ::selection {
    background: ${({ theme }) => theme.colors.boogaloo};
  }
`;

export const Italic = styled.strong`
  font-style: italic;
  font-weight: 300;

  ${Strong} & {
    font-weight: 900;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.boogaloo};
  }
`;

export const Paragraph = styled.p`
  margin: 0 0 2rem 0;

  ::selection {
    background: ${({ theme }) => theme.colors.boogaloo};
  }
`;

export const ListItem = styled.li`
  margin: 0 0 0.5rem 0;

  ::selection {
    background: ${({ theme }) => theme.colors.boogaloo};
  }
`;

export const UL = styled.ul`
  margin: 0 0 2rem;
  padding: 0 0 0 1.2em;

  ${ListItem} & {
    margin-bottom: 0;
    list-style-type: decimal;
  }

  ${ListItem} {
    list-style: none;
    position: relative;

    &:before {
      content: '—';
      position: absolute;
      left: -1.1em;
      color: ${({ theme }) => theme.colors.briangerine};
    }
  }
`;

export const OL = styled.ol`
  margin: 0 0 2rem;
  padding: 0 0 0 1.5em;
  list-style-type: decimal;

  ${ListItem} & {
    margin-bottom: 0;
    list-style-type: decimal;
  }
`;

export const LI = styled.li`
  margin-bottom: 1em;
`;

export const Cite = styled.cite``;

export const BQFooter = styled.footer`
  &::before {
    content: '— ';
    display: inline;
  }

  &,
  & ${Paragraph} {
    font-size: 1.6rem;
    font-weight: 900;
    text-align: center;

    ${Cite} {
      font-style: italic;
      border-bottom: 1px dotted ${({ theme }) => theme.colors.assfault};
    }
  }
`;

export const Blockquote = styled.blockquote`
  margin: 4em auto;

  ${Paragraph} {
    color: ${({ theme }) => theme.colors.assfault};
    font-size: 1.2em;
    font-weight: 100;
    text-align: center;
  }

  ${UL},
  ${OL} {
    margin: 1rem auto;
    width: 50%;
  }

  ${ListItem} {
    color: ${({ theme }) => theme.colors.assfault};
    font-size: 1em;
    font-weight: 100;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.boogaloo};
  }
`;

export const Span = styled.span``;
